module.exports = __webpack_public_path__ + "media/customizations/babcockranch/back-d250f0766ef83efef68823d0165f8720.jpg";